import styled from 'styled-components';

export const Flex = styled.div<FlexProps>`
	display: flex;
	flex-direction: ${props =>
		props.$flexDirection ? props.$flexDirection : 'row'};
	flex-wrap: ${props => (props.$flexWrap ? props.$flexWrap : 'unset')};
	width: ${props => (props.$width ? props.$width : '100%')};
	height: ${props => (props.$height ? props.$height : '100%')};
	min-width: ${props => (props.$minWidth ? props.$minWidth : 'unset')};
	max-width: ${props => (props.$maxWidth ? props.$maxWidth : 'unset')};
	min-height: ${props => (props.$minHeight ? props.$minHeight : 'unset')};
	max-height: ${props => (props.$maxHeight ? props.$maxHeight : 'unset')};
	justify-content: ${props =>
		props.$justifyContent ? props.$justifyContent : 'unset'};
	align-items: ${props => (props.$alignItems ? props.$alignItems : 'unset')};
	column-gap: ${props => (props.$columnGap ? props.$columnGap : 'unset')};
	row-gap: ${props => (props.$rowGap ? props.$rowGap : 'unset')};
	place-content: ${props => props.$placeContent && props.$placeContent};
	margin: ${props => (props.$margin ? props.$margin : '0')};
	padding: ${props => (props.$padding ? props.$padding : '0')};
	background-color: ${props =>
		props.$backgroundColor ? props.$backgroundColor : 'inherit'};
`;

interface FlexProps extends React.HTMLAttributes<HTMLDivElement> {
	$flexDirection?: string;
	$columnGap?: string;
	$rowGap?: string;
	$flexWrap?: string;
	$width?: string;
	$minWidth?: string;
	$maxWidth?: string;
	$height?: string;
	$minHeight?: string;
	$maxHeight?: string;
	$justifyContent?:
		| 'flex-start'
		| 'flex-end'
		| 'center'
		| 'space-between'
		| 'space-around'
		| 'space-evenly';
	$alignItems?: 'flex-start' | 'flex-end' | 'center' | 'baseline' | 'stretch';
	$placeContent?: string;
	$margin?: string;
	$padding?: string;
	$backgroundColor?: string;
}

export default Flex;
